module.exports = {"performed":"Performed","not_performed":"Not performed","na":"NA","tech_help":"Technical help","amenagement":"Arrangement","no_help":"Without help","light":"Light","heavy":"Heavy","full":"Full","low":"Without or small","medium":"Medium","lot":"Important","very_satisfied":"Very satisfied","satisfied":"Satisfied","unsatisfied":"Unsatisfied","very_unsatisfied":"Very unsatisfied"}


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang/en/header/criteria.json
// module id = eiXn
// module chunks = 24